import * as React from 'react'
import Typography from '@mui/material/Typography'

interface Props {
  children?: React.ReactElement | string
}

/**
 * リード文
 */
export const LeadSentence: React.FC<Props> = (props) => {
  const { children } = props

  return (
    <Typography
      component='p'
      sx={{
        color: '#000',
        mt: 2,
        mb: 4,
        textAlign: 'center'
      }}
    >
      {children}
    </Typography>
  )
}

export default LeadSentence
